import React from "react";
import Select from "react-select";
import Switch from "react-switch";
import Stack from "react-bootstrap/Stack";
import {nombreVendedor} from "../../_helpers";

import CargadorVersiones from "../../_helpers/CargadorVersiones";
class MenuFiltro extends React.Component {
    constructor(props) {
        super(props);
    }

    state = {
        dark: true
    }


    buscarMisModelos = (modelos, marcaId) => {
        let finalModelos = [];

        if (marcaId === undefined) {
            return finalModelos;
        }

        finalModelos = modelos?.filter((it) => it.marca.id === marcaId);

        return finalModelos;
    };

    buscarMisVersiones = (versiones, modeloId) => {
        let finalVersiones = [];

        if (modeloId === undefined) {
            return finalVersiones;
        }

        finalVersiones = versiones?.filter((it) => it.modelo.id === modeloId);

        return finalVersiones;
    };

    ordenarVendedores = (vendedores) =>
        (vendedores ?? [])
            .slice()
            .sort((a, b) => nombreVendedor(a).localeCompare(nombreVendedor(b)));

    /**
     * Aplica un filtro apenas se elige.
     *
     * <p>El filtro siempre se aplico en el onChange; el boton "Aplicar filtros" que
     * habia en mobile no aplicaba nada, solo cerraba el panel — y hasta que no lo
     * tocabas tapaba el listado que ya se habia actualizado atras. Ahora el panel se
     * cierra solo: el que lo abrio avisa como cerrarlo con `alAplicar`.
     *
     * <p>En desktop el panel no es un offcanvas sino una columna fija, asi que
     * `alAplicar` no llega y no hay nada que cerrar.
     */
    aplicar = (campo, valor) => {
        const {setFieldValue, submitForm, alAplicar} = this.props;

        setFieldValue(campo, valor);
        submitForm();

        if (alAplicar) alAplicar();
    };

    componentDidMount() {
        // const themeSwitcher = document.querySelector(".theme-switcher");
        let activeTheme = localStorage.getItem("theme");

        this.setState({dark: (activeTheme == 'dark' || activeTheme == undefined)})
        if (activeTheme) {
            this.changeTheme(activeTheme);
        } else {
            this.changeTheme('dark');
        }
    }

    changeTheme = (theme) => {
        document.body.classList.add("theme-switch");
        if (theme === "system") {
            localStorage.removeItem("theme");
            document.body.removeAttribute("data-theme");
        } else {
            localStorage.setItem("theme", theme);
            document.body.setAttribute("data-theme", theme);
        }

        document.body.addEventListener(
            "transitionend",
            () => {
                document.body.classList.remove("theme-switch");
            },
            {once: true}
        );
    }

    render() {
        /*
         * `ocultarTipoRepuesto`: en el listado de bajas el tipo ya esta fijado a "Baja" por la
         * propia pantalla, asi que ofrecer el combo solo serviria para salirse de ella.
         */
        const {filtros, values, ocultarTipoRepuesto} = this.props;
        const customSelect = {
            control: (provided) => ({ // class attribute : class=" css-i32vvf-control"
                ...provided,
                background: 'transparent',
                borderColor: 'transparent',
                height: '58px',
            }),
        };

        return (
            <>
                {/* Sin boton "Aplicar filtros": cada cambio se aplica y cierra el panel
                    desde this.aplicar(). */}
                <Stack>

                    {/* <Form.Label className="d-none d-sm-block">Filtrar por</Form.Label>
          <label className="switch__container mt-2">
            <span>¿Con stock?</span>
            <Switch
              onChange={(event) => {
                setFieldValue(`stock`, event);
                submitForm();

              }}
              checked={values.stock}
              onColor="#4c8ae6"
            />
          </label> */}

                    {/* <Form.Label>Tipo</Form.Label> */}

                    {!ocultarTipoRepuesto && (
                        <Select
                            className="sideBar-select"
                            cacheOptions
                            defaultOptions
                            isClearable={true}
                            value={
                                filtros?.tipoRepuestos
                                    ? filtros?.tipoRepuestos.find(
                                        (option) => option.id === values.tipoRepuesto?.id
                                    )
                                    : ""
                            }
                            placeholder="Tipo"
                            getOptionLabel={(option) => `${option.nombre}`}
                            getOptionValue={(option) => option.id}
                            options={filtros?.tipoRepuestos}
                            noOptionsMessage={({inputValue}) => !inputValue ? "Elija una marca" : "No se encontraron repuestos"}
                            onChange={(opt) => this.aplicar("tipoRepuesto", opt)}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            styles={customSelect}
                        />
                    )}

                    {/* <Form.Label>Marca</Form.Label> */}
                    <Select
                        className="sideBar-select"
                        cacheOptions
                        defaultOptions
                        isClearable={true}
                        value={
                            filtros?.marcas
                                ? filtros?.marcas.find(
                                    (option) => option.id === values.marca?.id
                                )
                                : ""
                        }
                        placeholder="Marca"
                        getOptionLabel={(option) => `${option.nombre}`}
                        getOptionValue={(option) => option.id}
                        options={filtros?.marcas}
                        noOptionsMessage={({inputValue}) => !inputValue ? "Elija una marca" : "No se encontraron marcas"}
                        onChange={(opt) => this.aplicar("marca", opt)}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={customSelect}
                    />

                    {/* <Form.Label>Modelo</Form.Label> */}
                    <Select
                        className="sideBar-select"
                        cacheOptions
                        defaultOptions
                        disabled={values.marca === undefined}
                        value={
                            filtros?.modelos
                                ? filtros?.modelos.find(
                                    (option) => option.id === values.modelo?.id
                                )
                                : ""
                        }
                        placeholder="Modelo"
                        isClearable={true}
                        getOptionLabel={(option) => `${option.nombre}`}
                        getOptionValue={(option) => option.id}
                        options={this.buscarMisModelos(filtros?.modelos, values.marca?.id)}
                        noOptionsMessage={({inputValue}) => !inputValue ? "Elija una marca" : "No se encontraron modelos"}
                        onChange={(opt) => this.aplicar("modelo", opt)}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={customSelect}
                    />

                    <CargadorVersiones modeloId={values.modelo?.id}/>

                    {/* <Form.Label>Versión</Form.Label> */}
                    <Select
                        className="sideBar-select"
                        cacheOptions
                        defaultOptions
                        isClearable={true}
                        disabled={values.modelo === undefined}
                        value={
                            filtros?.versiones
                                ? filtros?.versiones.find(
                                    (option) => option.id === values.version?.id
                                )
                                : ""
                        }
                        placeholder="Versión"
                        getOptionLabel={(option) => `${option.nombre}`}
                        getOptionValue={(option) => option.id}
                        options={this.buscarMisVersiones(
                            filtros?.versiones,
                            values.modelo?.id
                        )}
                        noOptionsMessage={({inputValue}) => !inputValue ? "Elija un modelo" : "No se encontraron versiones"}
                        onChange={(opt) => this.aplicar("version", opt)}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={customSelect}
                    />

                    <Select
                        className="sideBar-select"
                        cacheOptions
                        defaultOptions
                        isClearable={true}
                        value={
                            filtros?.provincias
                                ? filtros?.provincias.find(
                                    (option) => option.id === values.provincia?.id
                                )
                                : ""
                        }
                        placeholder="Provincia"
                        getOptionLabel={(option) => `${option.nombre}`}
                        getOptionValue={(option) => option.id}
                        options={filtros?.provincias}
                        noOptionsMessage={({inputValue}) => !inputValue ? "" : "No se encontraron provincias"}
                        onChange={(opt) => this.aplicar("provincia", opt)}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={customSelect}
                    />


                    {/* <Select
            className="sideBar-select"
            cacheOptions
            defaultOptions
            isClearable={true}
            value={
              filtros?.sitios
                ? filtros?.sitios.find(
                    (option) => option.id === values.sitio?.id
                  )
                : ""
            }
            placeholder="Sitio"
            getOptionLabel={(option) => `${option.nombre}`}
            getOptionValue={(option) => option.id}
            options={filtros?.sitios}
            onChange={(opt) => {
              setFieldValue("sitio", opt);
              submitForm();

            }}
            components={{
              IndicatorSeparator: () => null
            }}
            styles={customSelect}
          /> */}

                    <Select
                        className="sideBar-select"
                        cacheOptions
                        defaultOptions
                        isClearable={true}
                        value={
                            filtros?.vendedores
                                ? filtros?.vendedores.find(
                                    (option) => option.id === values.vendedor?.id
                                )
                                : ""
                        }
                        placeholder="Vendedor"
                        noOptionsMessage={({inputValue}) => !inputValue ? "" : "No se encontraron vendedores"}
                        getOptionLabel={nombreVendedor}
                        getOptionValue={(option) => option.id}
                        options={this.ordenarVendedores(filtros?.vendedores)}
                        onChange={(opt) => this.aplicar("vendedor", opt)}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={customSelect}
                    />

                    <fieldset className="theme-switcher margin-block-start-10">

                        <legend className="theme__switcher">Theme:</legend>

                        <div className="theme__switcher-options">

                            <Switch onChange={(event) => {
                                this.changeTheme(event ? 'dark' : 'light')
                                this.setState({dark: event});
                            }} checked={this.state.dark} onColor="#4c8ae6"
                            />
                            <span>Dark Mode</span>
                        </div>
                    </fieldset>


                </Stack>
            </>
        );
    }
}

export default MenuFiltro;
